import {
    CHANGE_NEW_SOLICITOR_PROPERTIES,
    RECEIVE_POST_NEW_SOLICITOR_RESPONSE,
    SOLICITOR_FORM_EMAIL_INFO,
    SOLICITOR_FORM_EMAIL_VALIDATION_ERROR,
    SOLICITOR_FORM_USERNAME_INFO,
    SOLICITOR_FORM_USERNAME_VALIDATION_ERROR,
    LOGOUT,
    REQUEST_NEW_SOLICITOR,
    RECEIVE_BAD_RESPONSE_POST_NEW_SOLICITOR,
    CHANGE_NEW_SOL_FORM_SETTINGS,
    REQUEST_PATCH_EXISTING_SOLICITOR,
    RECEIVE_PATCH_EXISTING_SOLICITOR_RESPONSE,
    RECEIVE_BAD_REQUEST_PATCH_EXISTING_SOLICITOR,
    RECEIVE_UPDATE_SOLICITOR_RESPONSE,
    RECEIVE_BAD_RESPONSE_UPDATE_SOLICITOR,
    NEW_SOLICITOR_UPDATE_LAWSYS_FIELD,
    RECEIVE_SOLICITOR_GROUPS,
    CHANGE_FIELD,
    REQUEST_GET_SELECTED_SOLICITOR_USER,
    RECEIVE_GET_SELECTED_SOLICITOR_USER,
    RECEIVE_BAD_REQUEST_GET_SELECTED_SOLICITOR_USER,
    CREATED_SOLICITOR_GROUP_RESPONSE,
    REQUEST_SEND_RESET_PASSWORD_EMAIL_TO_SOLICITOR,
    RECEIVE_SEND_RESET_PASSWORD_EMAIL_TO_SOLICITOR,
    RECEIVE_BAD_REQUEST_SEND_RESET_PASSWORD_EMAIL_TO_SOLICITOR,
    PATCH_SOLICITOR_GROUP,
    RECEIVE_RESPONSE_PATCH_SELECTED_SOLICITOR_GROUP,
    FAILED_PATCH_SOLICITOR_GROUP,
    REQUEST_GET_SOLICITOR_GROUPS,
    FAILED_TO_GET_SOLICITOR_GROUPS,
    RECEIVE_LAWSYS_FIRM_GROUP,
    UNLOCK_SOLICITOR_USER,
    UNLOCK_SOLICITOR_USER_SUCCESS,
    UNLOCK_SOLICITOR_USER_FAILED,
    CHANGE_SOLICITOR_USER_ADVANCE_DISBURSEMENTS

} from "../actions/index";

import _ from 'lodash';
import {IsJsonString} from "../helpers/functions";
import {FAILED_TO_RECEIVE_LAWSYS_FIRM_GROUP} from "../actions";
import {convertCaseSubCaseTypeDTOsToSubCaseTypeState} from '../helpers/advanceDisbursments/advanceDisbursements'
import {LEGAL_ADVICE_TEXT} from "../helpers/variables";

const defaultState = {
    solicitorForm: {
        emailInfoAppear: false,
        usernameInfoAppear: false,
        emailValidationError: false,
        usernameValidationError: false
    },
    newSolicitorFormData: {
        solicitorGroupName: "",
        solicitorGroupId: "",
        lawsysAgentId: "",
        lawsysAgentName: "",
        forename: "",
        surname: "",
        solicitorsEmailAddress: "",
        ccEmailAddress: "",
        userName: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        postcode: "",
        country: "",
        telephoneNumber1: "",
        telephoneNumber1Description: "",
        telephoneNumber2: "",
        telephoneNumber2Description: "",
        allowedToCreateApplications: true,
        allowedToSeeAllFirmApplications: false,
        disbursementsAllowed: false,
        disbursementsCaseSubCaseTypeDtos: [],
        selectedCaseTypes: [],
        checkedCaseTypesIds: [],
        selectedSubCaseTypes: [],
        checkedSubCaseTypesIds: [],
        advancedDisbursementsChecked: false,
        solicitorGroupAragProvider: null,
    },
    allSolicitors: [],
    responseMsg: '',
    posting: false,
    badResponse: '',
    notValidSolicitor: '',
    notValidTel1: '',
    notValidTel2: '',
    notValidEmail: '',
    notValidEmailCC: '',
    solicitorGroups: [],
    openModal: false,
    fetchingSolicitorUser: false,
    selectedUserId: '',
    sendingResetPasswordEmail: false,
    sentRestPasswordEmailErrorMsg: '',
    sentRestPasswordEmailRespMsg: '',
    selectedGroup: '',
    shouldRenderGroupSelect: false,
    patchingGroup: false,
    unlockingUser: false,
    unlockErrorMessage: null,

};

export default (state = defaultState, action) => {
    switch (action.type) {
        case UNLOCK_SOLICITOR_USER:
            return {
                ...state,
                unlockingUser: true,
                unlockErrorMessage: null
            };
        case UNLOCK_SOLICITOR_USER_SUCCESS:
            return {
                ...state,
                unlockingUser: false,
                unlockErrorMessage: null,
                newSolicitorFormData: {
                    ...state.newSolicitorFormData,
                    isLockedOutUntilUtc: null
                }
            };
        case UNLOCK_SOLICITOR_USER_FAILED:
            let unlockUserErrorMessage = "";
            try {
                unlockUserErrorMessage = action.payload.response.body.message
            } catch (e) {
                unlockUserErrorMessage = "Failed to unlock solicitor user."
            }
            return {
                ...state,
                unlockingUser: false,
                unlockErrorMessage: unlockUserErrorMessage
            };
        case FAILED_TO_RECEIVE_LAWSYS_FIRM_GROUP:
            return {
                ...state,
                newSolicitorFormData: {
                    ...state.newSolicitorFormData,
                    solicitorGroupName: '',
                    solicitorGroupId: '',
                    solicitorGroupAragProvider: null
                }
            };
        case RECEIVE_LAWSYS_FIRM_GROUP:
            let response;
            try {
                response = JSON.parse(action.payload.text)
            } catch (e) {
                response = null;
            }
            return {
                ...state,
                shouldRenderGroupSelect: response ? false : true,
                badResponse: response ? '' : 'Selected solicitor does not belong to a solicitor group.',
                newSolicitorFormData: {
                    ...state.newSolicitorFormData,
                    solicitorGroupName: response ? response.name : '',
                    solicitorGroupId: response ? response.id : '',
                    solicitorGroupAragProvider: response ? response.aragProvider || null : null
                }
            };
        case PATCH_SOLICITOR_GROUP:
            return {
                ...state,
                patchingGroup: true
            };
        case RECEIVE_RESPONSE_PATCH_SELECTED_SOLICITOR_GROUP:
            let newGroups = [];
            _.forEach(state.solicitorGroups, item => {
                if (item.id === action.payload.id) {
                    newGroups.push(action.payload)
                } else {
                    newGroups.push(item);
                }
            });
            return {
                ...state,
                patchingGroup: false,
                selectedGroup: '',
                shouldRenderGroupSelect: false,
                solicitorGroups: newGroups,
                badResponse: '',
                newSolicitorFormData: {
                    ...state.newSolicitorFormData,
                    solicitorGroupName: action.payload.name,
                    solicitorGroupId: action.payload.id,
                    solicitorGroupAragProvider: action.payload.aragProvider || null,
                }
            };
        case FAILED_PATCH_SOLICITOR_GROUP:
            return {
                ...state,
                patchingGroup: false
            };
        case REQUEST_SEND_RESET_PASSWORD_EMAIL_TO_SOLICITOR:
            return {
                ...state,
                sentRestPasswordEmailErrorMsg: '',
                sendingResetPasswordEmail: true,
                sentRestPasswordEmailRespMsg: ''
            };
        case RECEIVE_SEND_RESET_PASSWORD_EMAIL_TO_SOLICITOR:
            return {
                ...state,
                sentRestPasswordEmailErrorMsg: '',
                sendingResetPasswordEmail: false,
                sentRestPasswordEmailRespMsg: 'Email sent.'
            };
        case RECEIVE_BAD_REQUEST_SEND_RESET_PASSWORD_EMAIL_TO_SOLICITOR:
            return {
                ...state,
                sentRestPasswordEmailErrorMsg: action.payload,
                sendingResetPasswordEmail: false,
                sentRestPasswordEmailRespMsg: ''
            };
        case CREATED_SOLICITOR_GROUP_RESPONSE:
            return {
                ...state,
                openModal: false
            };
        case REQUEST_GET_SELECTED_SOLICITOR_USER:
            return {
                ...state,
                fetchingSolicitorUser: true
            };
        case RECEIVE_GET_SELECTED_SOLICITOR_USER:
            if (!action.payload) return state;
            let subCasesAndSubIds = convertCaseSubCaseTypeDTOsToSubCaseTypeState(action.payload)

            return {
                ...state,
                fetchingSolicitorUser: false,
                newSolicitorFormData: {
                    solicitorGroupName: action.payload.solicitorGroupName ? action.payload.solicitorGroupName : '',
                    solicitorGroupId: action.payload.solicitorGroupId ? action.payload.solicitorGroupId : '',
                    solicitorGroupAragProvider: action.payload.solicitorGroupAragProvider || null,
                    lawsysAgentId: action.payload.lawsysId ? action.payload.lawsysId : '',
                    lawsysAgentName: action.payload.lawsysName ? action.payload.lawsysName : '',
                    forename: action.payload.forename ? action.payload.forename : '',
                    surname: action.payload.surname ? action.payload.surname : '',
                    solicitorsEmailAddress: action.payload.email ? action.payload.email : '',
                    ccEmailAddress: action.payload.ccEmail ? action.payload.ccEmail : '',
                    userName: action.payload.username ? action.payload.username : '',
                    addressLine1: action.payload.addressLine1 ? action.payload.addressLine1 : '',
                    addressLine2: action.payload.addressLine2 ? action.payload.addressLine2 : '',
                    city: action.payload.city ? action.payload.city : '',
                    postcode: action.payload.postCode ? action.payload.postCode : '',
                    country: action.payload.country ? action.payload.country : '',
                    telephoneNumber1: action.payload.telephone1 ? action.payload.telephone1 : '',
                    telephoneNumber1Description: action.payload.telephone1Description ? action.payload.telephone1Description : '',
                    telephoneNumber2: action.payload.telephone2 ? action.payload.telephone2 : '',
                    telephoneNumber2Description: action.payload.telephone2Description ? action.payload.telephone2Description : '',
                    allowedToCreateApplications: action.payload.allowedToCreateApplications != null ? action.payload.allowedToCreateApplications : true,
                    allowedToSeeAllFirmApplications: action.payload.allowedToSeeAllFirmApplications != null ? action.payload.allowedToSeeAllFirmApplications : false,
                    isLockedOutUntilUtc: action.payload.isLockedOutUntilUtc,
                    selectedCaseTypes: action.payload.disbursementsCaseSubCaseTypeDtos ? action.payload.disbursementsCaseSubCaseTypeDtos.map(i => ({
                        id: i.id,
                        name: i.name
                    })) : [],
                    checkedCaseTypesIds: action.payload.disbursementsCaseSubCaseTypeDtos ? action.payload.disbursementsCaseSubCaseTypeDtos.map(i => i.id,) : [],
                    selectedSubCaseTypes: subCasesAndSubIds.adSubCaseTypes,
                    checkedSubCaseTypesIds: subCasesAndSubIds.adSubCaseTypesIds,
                    advancedDisbursementsChecked: action.payload.disbursementsAllowed ? action.payload.disbursementsAllowed : false,

                },


                selectedUserId: action.payload.userId
            };
        case RECEIVE_BAD_REQUEST_GET_SELECTED_SOLICITOR_USER:
            return {
                ...state,
                fetchingSolicitorUser: false
            };
        case CHANGE_FIELD:
            return {
                ...state,
                openModal: false,
                sentRestPasswordEmailErrorMsg: '',
                sentRestPasswordEmailRespMsg: ''
            };
        case REQUEST_GET_SOLICITOR_GROUPS:
            return {
                ...state,
                fetchingSolicitorGroups: true
            };
        case RECEIVE_SOLICITOR_GROUPS:
            return {
                ...state,
                solicitorGroups: action.payload.data,
                fetchingSolicitorGroups: false
            };
        case FAILED_TO_GET_SOLICITOR_GROUPS:
            return {
                ...state,
                fetchingSolicitorGroups: false
            };
        case SOLICITOR_FORM_EMAIL_INFO:
            return {
                ...state,
                solicitorForm: {...state.solicitorForm, emailInfoAppear: !state.solicitorForm.emailInfoAppear}
            };
        case SOLICITOR_FORM_USERNAME_INFO:
            return {
                ...state,
                solicitorForm: {...state.solicitorForm, usernameInfoAppear: !state.solicitorForm.usernameInfoAppear}
            };
        case SOLICITOR_FORM_EMAIL_VALIDATION_ERROR:
            return {
                ...state,
                solicitorForm: {...state.solicitorForm, emailValidationError: !state.solicitorForm.emailValidationError}
            };
        case SOLICITOR_FORM_USERNAME_VALIDATION_ERROR:
            return {
                ...state,
                solicitorForm: {
                    ...state.solicitorForm,
                    usernameValidationError: !state.solicitorForm.usernameValidationError
                }
            };
        case NEW_SOLICITOR_UPDATE_LAWSYS_FIELD:
            let lawsysFirmIndex = _.findIndex(action.payload.lawsysFirms, {id: parseInt(action.payload.id)});
            return {
                ...state,
                newSolicitorFormData: lawsysFirmIndex > -1 ? {
                    ...state.newSolicitorFormData,
                    lawsysAgentId: action.payload.id,
                    lawsysAgentName: action.payload.lawsysFirms[lawsysFirmIndex].name,
                    addressLine1: action.payload.lawsysFirms[lawsysFirmIndex].address,
                    postcode: action.payload.lawsysFirms[lawsysFirmIndex].postcode
                } : {
                    ...state.newSolicitorFormData,
                    lawsysAgentId: defaultState.newSolicitorFormData.lawsysAgentId,
                    lawsysAgentName: defaultState.newSolicitorFormData.lawsysAgentName,
                    addressLine1: defaultState.newSolicitorFormData.addressLine1,
                    postcode: defaultState.newSolicitorFormData.postcode,
                },
                badResponse: '',
                sentRestPasswordEmailErrorMsg: '',
                sentRestPasswordEmailRespMsg: '',
                selectedGroup: '',
                shouldRenderGroupSelect: false
            };
        case CHANGE_NEW_SOLICITOR_PROPERTIES:
            return {
                ...state,
                notValidTel1: '',
                notValidTel2: '',
                notValidEmail: '',
                notValidEmailCC: '',
                newSolicitorFormData: {...state.newSolicitorFormData, [action.payload.key]: action.payload.value},
                responseMsg: '',
                solicitorForm: {...state.solicitorForm, emailValidationError: false, usernameValidationError: false},
                sentRestPasswordEmailErrorMsg: '',
                sentRestPasswordEmailRespMsg: ''
            };
        case REQUEST_NEW_SOLICITOR:
            return {
                ...state,
                posting: true
            };
        case RECEIVE_BAD_RESPONSE_POST_NEW_SOLICITOR:
            if (action.payload === 'Email is already taken')
                return {
                    ...state,
                    posting: false,
                    badResponse: action.payload,
                    solicitorForm: {...state.solicitorForm, emailValidationError: true},
                    sentRestPasswordEmailErrorMsg: '',
                    sentRestPasswordEmailRespMsg: ''
                };
            else if (action.payload === 'Username is already taken') {
                return {
                    ...state,
                    posting: false,
                    badResponse: action.payload,
                    solicitorForm: {...state.solicitorForm, usernameValidationError: true},
                    sentRestPasswordEmailErrorMsg: '',
                    sentRestPasswordEmailRespMsg: ''
                };
            } else if (action.payload === 'Usename and Email are already taken') {
                return {
                    ...state,
                    posting: false,
                    badResponse: action.payload,
                    solicitorForm: {...state.solicitorForm, usernameValidationError: true, emailValidationError: true},
                    sentRestPasswordEmailErrorMsg: '',
                    sentRestPasswordEmailRespMsg: ''
                };
            } else
                return {
                    ...state,
                    posting: false,
                    badResponse: action.payload,
                    solicitorForm: {
                        ...state.solicitorForm,
                        emailValidationError: false,
                        usernameValidationError: false
                    },
                    sentRestPasswordEmailErrorMsg: '',
                    sentRestPasswordEmailRespMsg: ''
                };
        case RECEIVE_BAD_RESPONSE_UPDATE_SOLICITOR:
            return {
                ...state,
                posting: false,
                badResponse: action.payload,
                sentRestPasswordEmailErrorMsg: '',
                sentRestPasswordEmailRespMsg: ''
            };
        case RECEIVE_POST_NEW_SOLICITOR_RESPONSE:
            return {
                ...state,
                notValidTel1: '',
                notValidTel2: '',
                notValidEmail: '',
                notValidEmailCC: '',
                posting: false,
                newSolicitorFormData: defaultState.newSolicitorFormData,
                responseMsg: `${LEGAL_ADVICE_TEXT} User created.`,
                solicitorForm: {...state.solicitorForm, emailValidationError: false, usernameValidationError: false},
                badResponse: '',
                sentRestPasswordEmailErrorMsg: '',
                sentRestPasswordEmailRespMsg: ''
            };
        case RECEIVE_UPDATE_SOLICITOR_RESPONSE:
            return {
                ...state,
                notValidTel1: '',
                notValidTel2: '',
                notValidEmail: '',
                notValidEmailCC: '',
                posting: false,
                newSolicitorFormData: state.newSolicitorFormData,
                responseMsg: 'Changes saved.',
                solicitorForm: {...state.solicitorForm, emailValidationError: false, usernameValidationError: false},
                sentRestPasswordEmailErrorMsg: '',
                sentRestPasswordEmailRespMsg: '',

            };
        case REQUEST_PATCH_EXISTING_SOLICITOR:
            return {
                ...state,
                posting: true
            };
        case RECEIVE_PATCH_EXISTING_SOLICITOR_RESPONSE:
            if (!action.payload) return state;
            let subCasesAndSubIdsResponse = convertCaseSubCaseTypeDTOsToSubCaseTypeState(action.payload)
            return {
                ...state,
                notValidTel1: '',
                notValidTel2: '',
                notValidEmail: '',
                notValidEmailCC: '',
                posting: false,
                responseMsg: `${LEGAL_ADVICE_TEXT} updated successfully.`,
                solicitorForm: { ...state.solicitorForm, emailValidationError: false,usernameValidationError: false},
                newSolicitorFormData: {
                    ...state.newSolicitorFormData,
                    selectedCaseTypes: action.payload.disbursementsCaseSubCaseTypeDtos ? action.payload.disbursementsCaseSubCaseTypeDtos.map(i => ({
                        id: i.id,
                        name: i.name
                    })) : [],
                    selectedSubCaseTypes: subCasesAndSubIdsResponse.adSubCaseTypes,
                    checkedCaseTypesIds: action.payload.disbursementsCaseSubCaseTypeDtos ? action.payload.disbursementsCaseSubCaseTypeDtos.map(i => i.id,) : [],
                    checkedSubCaseTypesIds: subCasesAndSubIdsResponse.adSubCaseTypesIds,
                    advancedDisbursementsChecked: action.payload.disbursementsAllowed ? action.payload.disbursementsAllowed : false,
                },
                sentRestPasswordEmailErrorMsg: '',
                sentRestPasswordEmailRespMsg: ''
            };
        case RECEIVE_BAD_REQUEST_PATCH_EXISTING_SOLICITOR:
            if (action.payload === 'Email is already taken')
                return {
                    ...state,
                    posting: false,
                    badResponse: IsJsonString(action.payload.text) ? JSON.parse(action.payload.text) : 'Email is already taken.',
                    solicitorForm: {...state.solicitorForm, emailValidationError: true},
                    sentRestPasswordEmailErrorMsg: '',
                    sentRestPasswordEmailRespMsg: ''
                };
            else if (action.payload === 'Username is already taken') {
                return {
                    ...state,
                    posting: false,
                    badResponse: IsJsonString(action.payload.text) ? JSON.parse(action.payload.text) : 'Username is already taken.',
                    solicitorForm: {...state.solicitorForm, usernameValidationError: true},
                    sentRestPasswordEmailErrorMsg: '',
                    sentRestPasswordEmailRespMsg: ''
                };
            } else if (action.payload === 'Username and Email are already taken') {
                return {
                    ...state,
                    posting: false,
                    badResponse: IsJsonString(action.payload.text) ? JSON.parse(action.payload.text) : 'Username and Email are already taken.',
                    solicitorForm: {...state.solicitorForm, usernameValidationError: true, emailValidationError: true},
                    sentRestPasswordEmailErrorMsg: '',
                    sentRestPasswordEmailRespMsg: ''
                };
            } else
                return {
                    ...state,
                    posting: false,
                    badResponse: IsJsonString(action.payload.text) ? JSON.parse(action.payload.text) : 'Failed to update solicitor user.',
                    solicitorForm: {
                        ...state.solicitorForm,
                        emailValidationError: false,
                        usernameValidationError: false
                    },
                    sentRestPasswordEmailErrorMsg: '',
                    sentRestPasswordEmailRespMsg: ''
                };
        case CHANGE_NEW_SOL_FORM_SETTINGS:
            return {
                ...state,
                [action.payload.key]: action.payload.value,
                sentRestPasswordEmailErrorMsg: '',
                sentRestPasswordEmailRespMsg: ''
            };

        case CHANGE_SOLICITOR_USER_ADVANCE_DISBURSEMENTS: {
            return {
                ...state,
                newSolicitorFormData: {
                    ...state.newSolicitorFormData,
                    [action.payload.key]: action.payload.value
                }
            }
        };    
            
        case LOGOUT:
            return {
                ...defaultState
            };
        case '@@router/LOCATION_CHANGE':
            return {
                ...defaultState,
                allSolicitors: state.allSolicitors
            };
        default :
            return state
    }
}